import { useHistory } from 'react-router-dom';
import Header from './components/Header';
import Tile from './components/Tile';
import { capitalizeFirst } from 'components/Activity/utils/useActivityMapper';
import styles from './selectorList.module.css';
import clsx from 'clsx';

const StaticSelectorList = (props = {}) => {
	const { assignedList, label, textFieldLabel, full, linkTo } = props;

	const history = useHistory();

	const tileMapper = (val, index) => {
		if (!val) {
			return null;
		}
		const label = val.firstname
			? `${capitalizeFirst(val.firstname)} ${capitalizeFirst(val.lastname)}`
			: val.name
			? val.name
			: val.email.split('@')[0];

		return (
			<div key={`${val.id}${index}`}>
				<Tile
					image={val.photoUrl}
					value={val}
					select={linkTo ? () => history.push(`${linkTo}${val.id}`) : null}>
					{label}
				</Tile>
			</div>
		);
	};

	const tileMap = () => {
		if (!!assignedList && Boolean(assignedList.length)) {
			return assignedList.map(tileMapper);
		} else {
			return (
				<>
					<div className={styles.selectorListTileList}>
						{`No ${textFieldLabel} Assigned`}
					</div>
					<div style={{ paddingBottom: '25px' }} />
				</>
			);
		}
	};

	const id = label?.toLowerCase().replace(/ /g, '-') + '-selector-list-';

	return (
		<div
			className={clsx(
				styles.selectorListRoot,
				full ? styles.selectorListFull : styles.selectorListStandard
			)}
			id={id + 'root'}>
			<Header label={label} />
			<>
				<div className={styles.selectorListTileList}>{tileMap()}</div>
			</>
		</div>
	);
};

export default StaticSelectorList;
